import { useSelector } from "react-redux";
import {
  currentSelectedLanguage,
  setSearchedUserName,
} from "../../../../../StateManagement/actions";
import SettingsContainer from "../SettingsContainer";
import { useRef } from "react";
import { useFetchSettings } from "../../hooks/useFetchSettings";
import { useDispatch } from "react-redux";
import { storeSettingsData } from "../../../../../StateManagement/actions";
import useValidateSettings from "../../hooks/useValidateSettings";
import useSubmitSettings from "../../hooks/useSubmitSettings";
import { useState, useEffect } from "react";
import Alert from "../../../../Controls/Alerts/Alerts";
import LoadingSpinner from "../../../../Controls/Spinner/LoadingSpinner";
import WarnUnSaveChangesPopUp from "../../../../Shared/UnSaveChangesWarnPopUp/WarnUnSaveChangesPopUp";

const tabMap = {
  'Personal': 'personalTab',
  'Company': 'companyTab',
  'Admin': 'AdminTab'
};


export default function AdminDocument() {
  const selectedLanguage = useSelector(currentSelectedLanguage);
  const { submitChangedData } = useSubmitSettings();
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [alertType, setAlertType] = useState("");
  const [alertMsg, setAlertMsg] = useState("");
  const [openLoader, setOpenLoader] = useState(false);
  const searchedCompany = useSelector(
    (state) => state.settings.searchedCompany
  );

  const settings = useSelector((state) => state.settings);
  const tabKey = tabMap[settings.settingFor === "User" ? "Personal" : settings.settingFor];
  const commonSettings = settings[tabKey]?.settingsData;

  const companyNameRef = useRef(null);

  const { getActiveTabSettings } = useFetchSettings();

  const dispatch = useDispatch();

  // useEffect(() => {
  //   setTimeout(() => {
  //     setAlertMsg("");
  //     setAlertType("");
  //   }, 5000);
  // }, [alertType]);

  const onSearchHandler = async () => {

    if (companyNameRef.current.value !== "") {
      setOpenLoader(true);
      const result = await getActiveTabSettings("Document", "", companyNameRef.current?.value?.trim());
      if (result === "Company name does not exists.") {
        dispatch(setSearchedUserName({ searchText: "", companyName: "" }))
        dispatch(storeSettingsData({
          outerTabSelected: settings.settingFor,
          innerTabSelected: "Document",
          Settings: [],
        }));
        setAlertMsg(result);
        setAlertType('warning');
        setOpenLoader(false);
        return;
      }
      setOpenLoader(false);
      dispatch(setSearchedUserName({ searchText: "", companyName: companyNameRef.current?.value?.trim() }))
      return;
    }
    setAlertMsg(selectedLanguage.LstLanguageCodes.UI_EnterCompanyName);
    setAlertType("warning");
  };

  const onResetHandler = () => {
    companyNameRef.current.value = "";
    dispatch(setSearchedUserName({ searchText: "", companyName: "" }))
    dispatch(storeSettingsData({
      outerTabSelected: settings.settingFor,
      innerTabSelected: "Document",
      Settings: [],
    }));
  };

  const { showConfirmationPopup } = useValidateSettings();

  const onSaveHandler = () => {
    const isShowModal = showConfirmationPopup(settings);
    if (isShowModal) {
      setModalIsOpen(true);
    }
  }

  const onConfirm = async () => {
    setOpenLoader(true);
    const submitSettingsResponse = await submitChangedData();
    if (submitSettingsResponse.success) {
      setModalIsOpen(false);
      setAlertType("sucess");
      if (companyNameRef.current.value !== "") {
        await getActiveTabSettings("Document", "", companyNameRef.current.value);
      }
      setOpenLoader(false);
    }
    setOpenLoader(false);
    setModalIsOpen(false);

  }

  const onCancel = () => {
    setModalIsOpen(false);
  }

  return (
    <>
      <Alert
        alertType={alertType}
        alertMsg={alertMsg}
        setAlertMsg={setAlertMsg}
        setAlertType={setAlertType}
        className="alerthist"
        isfromSeetting="true"></Alert>
      {openLoader ? <LoadingSpinner /> : null}
      <div className="mb-3 comontab-heading2 ">
        <div className="search-heading-admin">
          <div className="row align-items-center px-3 py-3 bg-white">
            <div className="col-sm-4 ps-1 d-flex align-items-center">
              <input
                name="CompanyName"
                autoComplete="off"
                id="CompanyName"
                className="form-control red-shadow border-r4"
                type="text"
                ref={companyNameRef}
                placeholder={
                  selectedLanguage.LstLanguageCodes.UI_EnterCompanyName
                }
                aria-label="Search"
                onBlur={(e) => { e.target.value = e.target.value.trim(); }}
              />
            </div>
            <div className="col-sm-4 ps-1 d-flex align-items-center">
              <button
                className="btn btn-primary mx-3 serchicon"
                type="submit"
                onClick={onSearchHandler}>
                <span className="material-icons top3px">search</span>
              </button>
              <button
                className="btn btn-danger reseticon"
                type="reset"
                onClick={onResetHandler}>
                <span
                  className="material-icons top3px"
                  style={{ fontSize: "23px" }}>
                  not_interested
                </span>
              </button>
            </div>
          </div>
        </div>

        <div class="d-flex align-items-center justify-content-between comonheader-bg-Foradim">

          <h6 class=" font-16 font-w600 ps-3 ">
            {commonSettings.length === 0 ? selectedLanguage.LstLanguageCodes.UI_SearchByCompanyInAdmin : selectedLanguage.LstLanguageCodes.UI_viewingAdminsettings + ": " + (searchedCompany || companyNameRef.current?.value)}
          </h6>
          {commonSettings.length > 0 && <button type="button" class="btn sendsubmit px-2rem me-1" onClick={onSaveHandler}>
            Save
          </button>}
        </div>



      </div>

      <>
        {commonSettings.length > 0 && (
          <div
            className=" rounded p-2"
            id="v-tabs-admindocument1"
            role="tabpanel"
            aria-labelledby="v-tabs-admindocument1-tab">
            <div className="mb-2 row align-items-center mt-comapny-11rm tabsborder ">
              <div className="col-sm-3">
                <label
                  for="inputdateFormat"
                  className="col-form-label font-w600 control res-w">
                  {selectedLanguage.LstLanguageCodes.UI_Option}
                </label>
              </div>

              <div className="col-sm-4">
                <label
                  for="inputdateFormat"
                  className="col-form-label font-w600 control res-w">
                  {selectedLanguage.LstLanguageCodes.UI_DefaultSettings}
                </label>
              </div>
              <div className="col-sm-2 text-center px-0">
                <label
                  for="inputdateFormat"
                  className="col-form-label font-w600 control res-w">
                  {selectedLanguage.LstLanguageCodes.UI_OverrideUserSettings}
                </label>
              </div>

              <div className="col-sm-2 text-center">
                <label
                  for="inputdateFormat"
                  className="col-form-label font-w600 control res-w">
                  {selectedLanguage.LstLanguageCodes.UI_LockSettings}
                </label>
              </div>
              <div className="col-sm-1">
                <label
                  for="inputdateFormat"
                  className="col-form-label font-w600 control res-w">
                  {selectedLanguage.LstLanguageCodes.UI_History}
                </label>
              </div>
            </div>
            <SettingsContainer tabMenuText={"Document"} configLevel={""} />
          </div>
        )}
      </>
      <WarnUnSaveChangesPopUp
        isOpen={modalIsOpen}
        onConfirm={onConfirm}
        onCancel={onCancel}
      />
    </>
  );
}
